// removed by extract-text-webpack-plugin
module.exports = {"control":"cms__ToolbarPluginFormControl__control cms__ControlPane__control","label":"cms__ToolbarPluginFormControl__label cms__ControlPane__label"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/MarkdownControlElements/Toolbar/ToolbarPluginFormControl.css
// module id = 589
// module chunks = 0